import { Image, Text, View } from '@react-pdf/renderer'
import React, { useEffect, useState } from 'react'
import { headerStyles } from './headerStyles';
import { useDates } from '../../../../hooks/useDates';
import { useWebpToPng } from '../../../../hooks/useWebpToPng';
import { defaultTheme } from '../../../../theme/theme';

const { header } = headerStyles();


export const Header = ({ data, showTranslatedText }: any) => {

    const { TimeConverter } = useDates();

    const { convertWebpToPng } = useWebpToPng();
    const [convertedLogo, setConvertedLogo] = useState<string | null>(null);

    let signingDate = null;
    let regex = /\([^)]*\)/g;
    let salesInvoiceDate = null;
    let primaryColor= defaultTheme.palette.primary.main



    const isEmptyOrWhitespace = (str: string) => {
        return str.trim().length === 0;
    }

    if (!isEmptyOrWhitespace(data.dataInvoiceGeneral?.signing_date)) {
        signingDate = TimeConverter(data.dataInvoiceGeneral?.signing_date)?.toString();
        if (signingDate) {
            signingDate = signingDate.replace(regex, '').trim();
        }
    }

    if (!isEmptyOrWhitespace(data.dataInvoiceGeneral?.sales_invoice_date)) {
        salesInvoiceDate = TimeConverter(data.dataInvoiceGeneral?.sales_invoice_date)?.toString();
        if (salesInvoiceDate) {
            salesInvoiceDate = salesInvoiceDate.replace(regex, '').trim();
        }
    }

    useEffect(() => {
        if (data.dataInvoiceGeneral?.logoImage) {
            convertWebpToPng(data.dataInvoiceGeneral.logoImage).then(setConvertedLogo);
        }
    }, [data.dataInvoiceGeneral?.logoImage]);


    return (
        <View style={{
            height: 120,
            width: '100%',
            alignSelf: 'center',
            borderColor: 'black',
            flexDirection: 'row',
        }}>
            <View style={header.image}>
                <Image src={convertedLogo || " "} style={{ padding: 10 }} />
            </View>

            <View style={header.dataHeaderContainer}  >
                <View style={header.dataIssuingCompanyContainer}  >
                    <Text style={{
                        fontSize: 8,
                        paddingVertical: 3,
                        fontWeight: 700
                    }}>{data.dataInvoiceGeneral?.company_business_name || " "}</Text>
                    <Text style={[header.textHeaderStyles, { color: primaryColor }]}>{data.dataInvoiceGeneral?.company_street || " "}</Text>
                    <Text style={[header.textHeaderStyles, { color: primaryColor }]}>{data.dataInvoiceGeneral?.company_city_name || " "}, {data.dataInvoiceGeneral?.company_state_name || " "} {data.dataInvoiceGeneral?.company_postal_code || " "}, {data.dataInvoiceGeneral?.company_country_name || " "}</Text>
                    <Text style={{ fontSize: 8, paddingVertical: 3, fontWeight: 'bold' }}>RFC: {data.dataInvoiceGeneral?.company_rfc || " "}</Text>
                    <Text style={header.textHeaderStyles}>REGIMEN FISCAL: {data.dataInvoiceGeneral?.company_tax_regime_code || " "} {data.dataInvoiceGeneral?.company_tax_regime_description || " "}</Text>
                    <Text style={[header.textHeaderStyles,{ color: primaryColor }]}>{data.dataInvoiceGeneral?.company_email || " "}</Text>
                    <Text style={[header.textHeaderStyles,{ color: primaryColor }]}>{data.dataInvoiceGeneral?.company_phone_number || " "}</Text>
                </View>
                <View style={header.dataIssuingCompanyContainer}  >
                    <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', borderWidth: 1, width: '100%', paddingVertical: 4 , backgroundColor: primaryColor, borderRadius : 7}}>
                        <Text style={{ fontSize: 12, fontWeight: 600, color:'white' }}>{data.dataInvoiceGeneral?.invoice_doc_type_name || " "}</Text>
                    </View>
                    <View style={header.dataInvoiceGeneralSubcontainer}>
                        <Text style={header.textHeaderStylesBold}>{showTranslatedText("reports.salesInvoicePdf.header.folioNumber")}:</Text>
                        <Text style={[header.textHeaderStyles, {color: 'red'}]}>{data.dataInvoiceGeneral?.sales_invoice_name || " "}</Text>
                    </View>
                    <View style={{ flexDirection: 'column' }}>
                        <Text style={header.textHeaderStylesBold}>{showTranslatedText("reports.salesInvoicePdf.header.salesInvoiceDate")}:</Text>
                        <Text style={[header.textHeaderStyles,{ color: primaryColor }]}>{!salesInvoiceDate ? " " : salesInvoiceDate}</Text>
                    </View>
                    <View style={{ flexDirection: 'column' }}>
                        <Text style={header.textHeaderStylesBold}>{showTranslatedText("reports.salesInvoicePdf.header.taxNumber")}:</Text>
                        <Text style={[header.textHeaderStyles, { color: primaryColor }]}>{data.dataInvoiceGeneral?.uuid || " "}</Text>
                    </View>
                    <View style={{ flexDirection: 'column' }}>
                        <Text style={header.textHeaderStylesBold}>{showTranslatedText("reports.salesInvoicePdf.header.dateAndTimeCertification")}:</Text>
                        <Text style={[header.textHeaderStyles,{ color: primaryColor }]}>{!signingDate ? " " : signingDate}</Text>
                    </View>
                </View>
            </View>
        </View>

    )
}
